var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:#1b60a3}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.7 262v-77.9c18-1.2 50.5-6.6 72.9-29 31.8-31.8 29.3-84 29.2-86.2-.4-6.5-5.5-11.6-12-12-2.2-.1-54.4-2.6-86.2 29.2-3.4 3.4-6.4 7-9 10.8-4.7-18.7-13.4-39.7-29.8-56C197.7 3 135.2 6 132.5 6.1c-6.5.4-11.6 5.5-12 12-.1 2.6-3.1 65.2 34.9 103.2 27.8 27.8 68.8 33.7 89.8 34.8v106c4.2-.5 8.5-.7 12.7-.7 4.3-.1 8.6.2 12.8.6z",
    style: {
      fill: "#39beec"
    },
    id: "Layer_2"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 137.3,
    cy: 371,
    r: 109.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 250.9,
    cy: 331,
    r: 109.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 364.5,
    cy: 371,
    r: 109.4
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    id: "Layer_4_1_",
    d: "M21 400h461v89H21z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPools);
export default __webpack_public_path__ + "static/media/Pools.8a6f3d3a3e8f893adc980f93e052e135.svg";
export { ForwardRef as ReactComponent };